import styled from "styled-components";

export const FlexColumnBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const AddPageTitleBox = styled.div`
  font-weight: 800;
  font-size: 36px;
  margin-top: 26px;
  margin-bottom: 26px;
  border-bottom: 2px solid #ffc20c;
`;

export const InputTextFull = styled.input`
  background-color: white;
  width: 100%;
  border-radius: 4px;
`;

export const AddBackBox = styled.div`
  width: 100%;
  padding: 20px;
  border: 1px solid gray;
  border-radius: 16px;
  background-color: white;
`;

export const AddContentBox = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
  padding-top: 20px;
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const FlexCenter2 = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  margin-right: 32px;
  width: 100px;
  white-space: nowrap;
`;
// whiteSpace: "nowrap",

export const ContentTitle2 = styled.div`
  font-weight: 600;
  font-size: 24px;
  margin-right: 32px;
  white-space: nowrap;
  width: 80px;
  display: flex;
  justify-content: ${(props) => props.justify || "end"};
  align-items: ${(props) => props.align || "center"};
`;
export const SelectBox = styled.select`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  width: 290px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-align-last: center;
  background-color: white;

  @media (max-width: 580px) {
    width: 200px;
  }

  @media (max-width: 450px) {
    width: 150px;
  }
`;

export const FlexStart = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

export const MyPcFile = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: gray;
  justify-content: space-between;
  margin-top: 6px;
`;

export const MyPcButton = styled.button`
  padding: 5px 10px;
`;

export const FileListBox = styled.div`
  display: flex;
  min-height: 150px;
  background-color: white;
`;

export const FlexBorder = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid black;
  flex-direction: column;
`;

export const FlexSbBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FileDeleteBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 5px;
`;

export const FlexMR10 = styled.div`
  display: flex;
  margin-right: 10px;
`;

export const ConsentTitleBox = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid gray;
`;

export const ConsentFirstBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const ConsentTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  margin-right: 32px;
  white-space: nowrap;
  width: 100px;
  margin-bottom: 10px;
  color: gray;
`;

export const ConsentArea = styled.textarea`
  background-color: white;
  width: 100%;
  border-radius: 4px;
  height: 200px;
`;

export const ConsentArea2 = styled.div`
  background-color: white;
  width: 100%;
  border-radius: 4px;
  height: 200px;
  border: 1px solid gray;
  padding: 10px;
  overflow-y: auto;
`;

export const AddPageBottomBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const AddCheckBoxText = styled.div`
  font-weight: 700;
  font-size: 16px;
`;
